import Pepperoni from "../assets/pepperoni.jpg";
import Margherita from "../assets/margherita.jpg";
import PedroTechSpecial from "../assets/pedrotechspecial.jpg";
import Vegan from "../assets/vegan.jpg";
import Pineapple from "../assets/pineapple.jpg";
import Expensive from "../assets/expensive.jpg";

export const MenuList = [
  {
    name: "React Pizza",
    image: Pepperoni,
    price: 15.99,
  },
  {
    name: "Github Pizza",
    image: Margherita,
    price: 11.99,
  },
  {
    name: "Fintech Special Pizza",
    image: PedroTechSpecial,
    price: 256.53,
  },
  {
    name: "Netlify Pizza",
    image: Vegan,
    price: 17.99,
  },
  {
    name: "Heroku Pizza",
    image: Pineapple,
    price: 4.99,
  },
  {
    name: "Bitcoin Pizza",
    image: Expensive,
    price: 1997.99,
  },
];
